import { MessageType } from '../../../toastMessage/types';
import { IAnalyticsErrorArgument, IAnalyticsEventError } from './types';
import { UnreachableCaseError } from 'ts-essentials';

export const getErrorAnalyticsEventFromToast = (
  type: MessageType,
  message: string,
): IAnalyticsEventError | null => {
  if (type === 'info' || type === 'action') {
    // no event if the toast is not an error
    // placed first because it is more common
    return null;
  } else if (type === 'error') {
    return toastErrorViewed({ message });
  } else {
    throw new UnreachableCaseError(type);
  }
};

const toastErrorViewed = ({
  message,
  context,
}: IAnalyticsErrorArgument): IAnalyticsEventError => {
  return {
    eventName: 'Toast Error Viewed',
    object_type: 'error',
    object_name: message,
    context,
  };
};

export const formErrorViewed = ({
  message,
  context,
}: IAnalyticsErrorArgument): IAnalyticsEventError => {
  return {
    eventName: 'Form Error Viewed',
    object_type: 'error',
    object_name: message,
    context,
  };
};
